import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { CheckCircle2, Phone } from 'lucide-react';
export function CustomTileWorkPage() {
  return <div className="flex flex-col min-h-screen pt-24 pb-20" data-id="element-297">
      {/* Hero */}
      <section className="relative bg-gray-50 py-16 md:py-24 overflow-hidden" data-id="element-298">
        <div className="absolute inset-0 z-0" data-id="element-299">
          <img src="https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&q=80&w=2000" alt="Custom tile work" className="w-full h-full object-cover object-center" data-id="element-300" />
          <div className="absolute inset-0 bg-white/85" data-id="element-301"></div>
        </div>

        <div className="container relative z-10 mx-auto px-4 md:px-6" data-id="element-302">
          <div className="max-w-3xl mx-auto text-center" data-id="element-303">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-304">
              Custom Tile Work in Northern Indiana
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-8" data-id="element-305">
              Expert tile installation for floors, walls, showers, and
              backsplashes
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-306">
              <Link to="/contact" data-id="element-307">
                <Button size="lg" data-id="element-308">Get Free Consultation</Button>
              </Link>
              <Button variant="outline" size="lg" data-id="element-309">
                <Phone className="mr-2 h-5 w-5" data-id="element-310" />
                (574) 914-1522
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16" data-id="element-311">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-312">
          <div className="prose prose-lg max-w-none" data-id="element-313">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-314">
              Professional Tile Installation Services
            </h2>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-315">
              Custom tile work transforms ordinary bathrooms into stunning
              spaces that reflect your personal style. At Lucky Duck Bathroom
              Company, we specialize in precision tile installation throughout
              Northern Indiana, delivering beautiful, durable results that stand
              the test of time. From classic subway tile to intricate mosaic
              patterns, our skilled craftsmen bring your design vision to life
              with meticulous attention to detail.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-316">
              Our Custom Tile Services
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-317">
              We offer comprehensive tile installation services for every area
              of your bathroom. Our expertise includes shower walls and floors,
              bathroom floors, tub surrounds, backsplashes, accent walls, and
              decorative borders. Whether you're updating a single surface or
              completing a full bathroom renovation, we handle every aspect of
              the tile installation process with professional care.
            </p>

            <div className="bg-gray-50 p-6 rounded-lg mb-6" data-id="element-318">
              <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-319">
                Tile Options We Install:
              </h4>
              <ul className="space-y-3" data-id="element-320">
                {['Ceramic tile - affordable, versatile, easy to maintain', 'Porcelain tile - durable, water-resistant, ideal for high-traffic areas', 'Natural stone - marble, granite, travertine for luxury appeal', 'Glass tile - modern, reflective, perfect for accents', 'Mosaic tile - intricate patterns and custom designs', 'Large format tile - contemporary look with fewer grout lines'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-321">
                    <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-0.5" data-id="element-322" />
                    <span className="text-gray-700" data-id="element-323">{item}</span>
                  </li>)}
              </ul>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-324">
              Why Professional Tile Installation Matters
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-325">
              Proper tile installation requires more than just setting tiles in
              place. It demands careful surface preparation, precise layout
              planning, correct adhesive application, and expert grouting
              techniques. Poor installation leads to cracked tiles, water
              damage, mold growth, and premature failure—problems that cost far
              more to fix than doing it right the first time.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-326">
              Our team follows industry best practices for every installation.
              We properly prepare substrates, use appropriate waterproofing
              membranes in wet areas, ensure proper slope for shower floors,
              maintain consistent grout lines, and seal surfaces as needed.
              These details make the difference between tile work that looks
              good for a few years and installations that remain beautiful and
              functional for decades.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-327">
              Custom Design Possibilities
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-328">
              Tile offers endless design possibilities to express your style.
              Create dramatic feature walls with contrasting colors or textures,
              add elegant borders and medallions, incorporate decorative
              listello strips, design custom shower niches with complementary
              tile, or mix materials for unique visual interest. We work with
              you to select patterns, layouts, and color combinations that
              enhance your bathroom's overall aesthetic.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-329">
              Whether you prefer timeless classics like white subway tile with
              dark grout, modern large-format porcelain in neutral tones, or
              bold geometric patterns that make a statement, we have the skills
              and experience to execute your vision flawlessly. Our team can
              also provide design guidance and recommendations based on your
              space, budget, and lifestyle needs.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-330">
              The Lucky Duck Difference
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-331">
              As a family-owned business serving Northern Indiana, we take pride
              in delivering tile installations that exceed expectations. Our
              craftsmen have years of experience working with all types of tile
              materials and installation methods. We use quality products from
              trusted suppliers, maintain clean and organized work areas, and
              complete projects on schedule with minimal disruption to your
              daily routine.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-332">
              We serve homeowners throughout South Bend, Mishawaka, Elkhart,
              Goshen, Granger, and surrounding communities with honest pricing,
              superior workmanship, and the personalized attention you deserve.
              Every tile installation is backed by our commitment to quality and
              customer satisfaction.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-333">
              Maintenance and Care
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-334">
              Properly installed tile is remarkably durable and easy to
              maintain. We provide care instructions specific to your tile type
              and finish, including recommended cleaning products, sealing
              schedules for natural stone, and tips for keeping grout looking
              fresh. With basic maintenance, your custom tile work will retain
              its beauty and functionality for many years to come.
            </p>

            <div className="bg-[#8BA888]/10 border-l-4 border-[#8BA888] p-6 rounded-r-lg mt-8" data-id="element-335">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-336">
                Ready for Beautiful Custom Tile Work?
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-337">
                Contact Lucky Duck Bathroom Company for a free consultation and
                let's discuss how custom tile can transform your bathroom.
              </p>
              <Link to="/contact" data-id="element-338">
                <Button size="lg" data-id="element-339">Schedule Free Consultation</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}